import { graphql, PageProps } from 'gatsby';
import React, { useEffect } from 'react';

import { AnalyticsPageType } from '@shopify/hydrogen-react';

import SeoHead from '../../../components/head';
import { StructuredSchemaData } from '../../../components/structuredSchemaData';
import { useAnalytics } from '../../../shared/analytics';
import { ContentfulPageContent } from './content';

export default function ContentfulPage(props: PageProps<Queries.ContentfulPageContentQuery>) {
  const analytics = useAnalytics();
  useEffect(() => {
    // const pageType = props.data.slug === 'terms-of-service' || props.data.slug === 'privacy-policy' || props.data.slug === 'shipping-policy' || props.data.slug === 'refund-policy' ? AnalyticsPageType.policy : AnalyticsPageType.page;
    analytics.trackPageView(AnalyticsPageType.page);
  }, [])

  const showPageTitle = props.data.pageData.showPageTitle === true || props.data.pageData.showPageTitle === undefined || props.data.pageData.showPageTitle === null;

  return (
    <ContentfulPageContent {...props} showTitle={showPageTitle} />
  )
}
export const Head = (props: PageProps<Queries.ContentfulPageContentQuery>) => {
  const { pageData } = props.data

  return (
    <SeoHead title={pageData.title} description={pageData.description} pathname={props.location.pathname}>
      <StructuredSchemaData queryItems={props.data.pageData.structuredSchemaData} />
    </SeoHead>
  )
}

export const query = graphql`
  query ContentfulPageContent($id: String!) {
    pageData: contentfulPage(id: { eq: $id }) {
      id
      title
      description
      contentful_id
      showPageTitle
      slug
      __typename
      blocks: content {
        blockType: __typename
        ...HomepageHeroContent
        ...RichTextBlockContent
        ...HomepageFeatureListContent
        ...HomepageCtaContent
        ...HomepageProductListContent
      }
      structuredSchemaData {
        id
        itemType: __typename
        questionText
          answerText {
            raw
          }
      }
    }
  }
`
